import React from 'react';

// Investment Focus - Stages. 56x56 gradient-bordered tile (the frame is part of
// the artwork), glyph exactly as Figma drew it. Gradient ids are per-instance
// (useId) so several icons on one page don't share ids and break.
const GRADIENT_STOPS = (
  <>
    <stop stopColor="#7458F6" />
    <stop offset="1" stopColor="#84AEF8" />
  </>
);

const StagesIcon = ({ size = 56 }) => {
  const uid = React.useId();
  const g = (n) => `stages_${uid}_${n}`;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <rect x="0.5" y="0.5" width="55" height="55" rx="11.5" stroke={`url(#${g(0)})`} />
      <path
        d="M28 39V23"
        stroke={`url(#${g(1)})`}
        strokeWidth="2.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M28 27C22 27 18.3333 24 17 18C23 18 26.6667 21 28 27Z"
        stroke={`url(#${g(2)})`}
      />
      <path
        d="M28 24C34 24 37.6667 21 39 15C33 15 29.3333 18 28 24Z"
        stroke={`url(#${g(3)})`}
      />
      <defs>
        <linearGradient id={g(0)} x1="28" y1="0" x2="28" y2="56" gradientUnits="userSpaceOnUse">
          {GRADIENT_STOPS}
        </linearGradient>
        <linearGradient id={g(1)} x1="28.5" y1="23" x2="28.5" y2="39" gradientUnits="userSpaceOnUse">
          {GRADIENT_STOPS}
        </linearGradient>
        <linearGradient id={g(2)} x1="22.5" y1="18" x2="22.5" y2="27" gradientUnits="userSpaceOnUse">
          {GRADIENT_STOPS}
        </linearGradient>
        <linearGradient id={g(3)} x1="33.5" y1="15" x2="33.5" y2="24" gradientUnits="userSpaceOnUse">
          {GRADIENT_STOPS}
        </linearGradient>
      </defs>
    </svg>
  );
};

export default StagesIcon;
